import { BehaviorSubject } from 'rxjs';
import scrollLock from 'scroll-lock';
import * as i0 from "@angular/core";
var ToastService = /** @class */ (function () {
    function ToastService() {
        this.htmlElement = document.getElementsByTagName('html');
        this.isOpen = new BehaviorSubject(false);
        this.message = new BehaviorSubject('');
        this.type = new BehaviorSubject('default');
        this.duration = new BehaviorSubject(3);
        this.showClose = new BehaviorSubject(false);
        this.lookScreen = new BehaviorSubject(true);
    }
    /**
     * Opens a toast with the given message, of the given (optional) type for
     * the given duration
     * @param message - the message to present on the toast
     * @param type - the type (class) of the toast. Defaults to 'default'.
     * @param duration - how long the toast stays on screen. Defaults to 3 seconds.
     * @param showClose - show close button on the toast. Defaults to false.
     * @param lookScreen - Look screen scroll when showing toast. Defaults to true.
     */
    ToastService.prototype.open = function (message, type, duration, showClose, lookScreen) {
        if (type === void 0) { type = 'default'; }
        if (duration === void 0) { duration = 3; }
        if (showClose === void 0) { showClose = false; }
        if (lookScreen === void 0) { lookScreen = true; }
        this.isOpen.next(true);
        this.message.next(message);
        this.type.next(type);
        this.duration.next(duration);
        this.showClose.next(showClose);
        this.lookScreen.next(lookScreen);
        this.isOpen.next(true);
        // Disable scroll on body
        if (lookScreen) {
            // Disable scroll on body
            this.htmlElement[0].classList.add('no-scroll');
            scrollLock.hide();
        }
    };
    ToastService.prototype.close = function () {
        this.isOpen.next(false);
        // Enable scroll on body again
        this.htmlElement[0].classList.remove('no-scroll');
        scrollLock.show();
    };
    ToastService.ngInjectableDef = i0.defineInjectable({ factory: function ToastService_Factory() { return new ToastService(); }, token: ToastService, providedIn: "root" });
    return ToastService;
}());
export { ToastService };
